module.exports = __webpack_public_path__ + "static/media/SmartShop_5-346w.9bbd1355.png";